import React from 'react'
import { styled, Grid as BaseGrid } from '@mui/material'
import { Card as BaseCard } from '@chilecompra/react-kit/components'

export const Root = styled('div')`
  width: 100%;
  margin-top: 20px;
`

export const Card = styled(({ textAlign, ...props }) => <BaseCard {...props} />)`
  &.MuiPaper-root * {
    text-align: ${props => props.textAlign};
  }
`

export const Column = styled(({ align, margin, padding, width, ...props }) => <BaseGrid item {...props} />)`
  margin: ${props => props.margin || '0'};
  padding: ${props => props.padding || '8px 0'};
  text-align: ${props => props.align || 'start'};
  width: ${props => props.width};
`

export const ExternalLink = styled('a')`
  color: ${props => props.theme.palette.brand.primary};
  cursor: pointer;
  font-size: 14px;
  line-height: 22px;
  padding: 0.3rem 0.8rem;
  text-decoration: none;

  &:hover {
    color: ${props => props.theme.palette.blue[35]};
    text-decoration: underline;
  }
`

export const NotFoundImg = styled('img')`
  color: ${props => props.theme.palette.brand.black3};
  height: auto;
  width: 82px;
`

export const Paragraph = styled('p')`
  &.dni {
    color: ${props => props.theme.palette.brand.black1};
    font-size: 14px;
    font-weight: 600;
    line-height: 16px;
    padding: 0 0 0 20px;
  }

  &.orgLegalName {
    color: ${props => props.theme.palette.brand.black1};
    font-size: 14px;
    font-weight: 400;
    line-height: 16px;
    margin: ${props => props.margin || '1em 0'};
    padding: 0 20px 0 20px;
    text-align: left;
  }
`

export const Row = styled(({ margin, padding, ...props }) => <BaseGrid container {...props} />)`
  margin: ${props => props.margin || '0 -5px'};
  padding: ${props => props.padding || '0'};
  width: ${props => props.width};
`

export const Strong = styled('span')`
  font-weight: bold;
`
